import { defineCustomElements } from '@ionic/pwa-elements/loader'
import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const container = document.getElementById('root')

if (container) {
  const root = createRoot(container)

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}

defineCustomElements(window)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// if web or mobileweb

serviceWorkerRegistration.unregister()

// if (Capacitor.isNativePlatform()) {
//   serviceWorkerRegistration.unregister()
// } else {
//   serviceWorkerRegistration.register()
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

if (window.self !== window.top) {
  // Code is running inside an iframe
  console.log('This code is running inside an iframe.')

  const getAuthToken = () => window.store.getState().session.authToken
  window.onload = async () => {
    const { receiveFromParent, sendToParent } = await import('./messages')

    /* Communication between iFrame and Ionic */
    window.removeEventListener('message', receiveFromParent)
    window.addEventListener('message', receiveFromParent)

    sendToParent({ name: 'loaded' })
    // safe loading so that view never stays blank when oopened
    setTimeout(() => {
      if (!getAuthToken()) sendToParent({ name: 'loaded' })
    }, 200)

    setTimeout(() => {
      if (!getAuthToken()) sendToParent({ name: 'loaded' })
    }, 2000)
  }
} else {
  // Code is not running inside an iframe
  console.log('This code is not running inside an iframe.')
}

document.addEventListener('gesturestart', (e) => e.preventDefault())
